import $ from 'jquery';

import { PaymentCalculatorFactory, Formatter } from '@dealersites/dealersite-js-core';

const summaryPage = $('#container-summary');
if (summaryPage.length !== 0) {
  const summaryTotal = $('.SummaryTotal');
  const financeSelect = $('.FinanceSelect');
  const leaseSelect = $('.LeaseSelect');
  const financeTotal = $('.FinanceTotal');
  const leaseTotal = $('.LeaseTotal');

  let summaryTotalValue = parseInt(summaryTotal.data('total'));

  $('.CollapseButtons').on('click', function () {
    $(this).find('.fa').toggleClass('fa-minus fa-plus');
  });

  $('.ButtonToggleForms').on('click', function () {
    $('.ButtonToggleForms').removeClass('active');
    $(this).addClass('active');

    const target = $(this).data('target');
    $('.CollapseForm').not(target).removeClass('show');
  });

  $('.IncentivesCheckbox').change(function () {
    const incentiveValue = parseInt($(this).data('cash'));
    const incentiveId = $(this).attr('id');
    summaryTotalValue = this.checked
      ? summaryTotalValue - incentiveValue
      : summaryTotalValue + incentiveValue;

    summaryTotal.text(Formatter.price(summaryTotalValue, 2));
    updateBreakdown(incentiveId);
  });

  /**
   * Updates the breakdown section of the summary page.
   *
   * @param {String}        description
   */
  function updateBreakdown(description) {
    $('#js-' + description).toggleClass(
      'BreakdownItemHide BreakdownItemShow mt-2',
      'BreakdownItemHide BreakdownItemShow mt-2',
    );
  }

  /**
   * Updates the financing values in the calculator on the summary page
   *
   * @param price
   * @param term
   * @param rate
   */
  function updateFinancingCalculator(price, term, rate) {
    const calcInputs = {
      price: price,
      term: term,
      rate: rate,
      tax: 0,
    };

    const financeCalc = PaymentCalculatorFactory.createCalculator('finance', calcInputs);
    financeCalc.calculate();
    financeTotal.text(Formatter.price(financeCalc.payments.monthly, 2));
    $(`.FinanceValue`).text(rate.toFixed(2));
  }

  /**
   * Updates the leasing values in the calculator on the summary page
   *
   * @param price
   * @param term
   * @param rate
   * @param residual
   */
  function updateLeasingCalculator(price, term, rate, residual) {
    const calcInputs = {
      price: price,
      term: term,
      rate: rate,
      residual: residual,
      tax: 0,
    };

    const leaseCalc = PaymentCalculatorFactory.createCalculator('lease', calcInputs);
    leaseCalc.calculate();
    leaseTotal.text(Formatter.price(leaseCalc.payments.monthly, 2));
    $(`.LeaseValue`).text(rate.toFixed(2));
    $(`.LeaseResidualValue`).text(Formatter.price(residual, 2));
  }

  // Calculator Event Listeners
  financeSelect.change(function () {
    let finance = financeSelect.data('finance');
    let selectedVal = $(this).val().split('-');

    updateFinancingCalculator(
      summaryTotalValue,
      finance[selectedVal[0]].to,
      finance[selectedVal[0]].value,
    );
  });

  leaseSelect.change(function () {
    let lease = leaseSelect.data('lease');
    let selectedVal = $(this).val().split('-');
    let residualValue = lease[selectedVal[0]].residual_value
      ? summaryTotalValue * (lease[selectedVal[0]].residual_value / 100)
      : 0;

    updateLeasingCalculator(
      summaryTotalValue,
      lease[selectedVal[0]].to,
      lease[selectedVal[0]].value,
      residualValue,
    );
  });

  // Initialize calculator
  updateFinancingCalculator(
    financeTotal.data('price'),
    financeTotal.data('term'),
    financeTotal.data('rate'),
  );
  updateLeasingCalculator(
    leaseTotal.data('price'),
    leaseTotal.data('term'),
    leaseTotal.data('rate'),
    leaseTotal.data('residual'),
  );
}
